import axios from 'axios'
import ResourceConstants from '../constants/ResourceConstants'

const findMyTeamGateway = axios.create({
  baseURL: ResourceConstants.KONG_CUSTOMER_API,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

const customerGateway = axios.create({
  baseURL: ResourceConstants.CUSTOMER_API,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

const billingGateway = axios.create({
  baseURL: ResourceConstants.BILLING_API,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

export const sendVerificationEmail = (email) => {
  return findMyTeamGateway.post(`/findTeam/verifyEmail`, { email })
}

export const retrieveDomains = (token) => {
  return findMyTeamGateway.post('/findTeam/getDomains', { token })
    .then(response => response.data)
}

export const joinOrg = (orgId, token) => {
  return findMyTeamGateway.post(`/findTeam/joinOrg?orgId=${orgId}`, { token })
}

export const getTransferOrgName = (token) => {
  return findMyTeamGateway.post(`/users/transferOrg`, { token })
    .then(response => response.data)
}

export const transferUser = (token) => {
  return findMyTeamGateway.post(`/users/transferMe?clientId=${ResourceConstants.DEFAULT_CLIENT_ID}`, { token })
    .then(response => response.data)
}

export const addTeammate = (payload, orgId, token) => {
  return customerGateway.post(`/organizations/${orgId}/users/invite/relay?relayToken=${token}`, payload)
}

export const getBillingInfoAndRelay = (relayToken, captureError) => {
  return billingGateway.get(`/info/relay?relayToken=${relayToken}`)
    .then(response => response.data)
    .catch(error => captureError(error))
}

export const hasMultiOrg = (token) => {
  return findMyTeamGateway.post('/multi_org/state/relay', { token })
}



// WEBPACK FOOTER //
// ./src/api/findmyteam.js